// removed by extract-text-webpack-plugin
module.exports = {"wrap":"qempo_Scrap_wrap-zpBXg4N","banner":"qempo_Scrap_banner-xmtkSMJ","newScrap":"qempo_Scrap_newScrap-3mFNuxt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/scrap/components/Scrap.scss
// module id = 2281
// module chunks = 0